import { AUTH, ONBOARDING as ONBOARDING_PAGES, OVERVIEW } from '@hotjar/webapp/constants/routes';
import { getRouteConfigByPath } from '@hotjar/webapp/utils/routing';

export const isUrlOnboarding = (pathname = window.location.pathname): boolean => {
  const currentRoute = getRouteConfigByPath(pathname);
  return currentRoute?.name === ONBOARDING_PAGES.ONBOARDING.name;
};

export const isUrlRegistration = (pathname = window.location.pathname): boolean => {
  const currentRoute = getRouteConfigByPath(pathname);
  return currentRoute?.name === AUTH.REGISTER.name;
};

export const isUrlSetup = (pathname = window.location.pathname): boolean => {
  const currentRoute = getRouteConfigByPath(pathname);
  return currentRoute?.name === OVERVIEW.SETUP.name;
};

export const shouldShowOnboardingProgressBar = isUrlOnboarding() || isUrlSetup();
